import React from "react"
import { cn } from "~/ui-rtk/utils/tailwind-utils"

export type CheckboxWithLabelProps =
  React.InputHTMLAttributes<HTMLInputElement> & {
    className?: string
    checked?: boolean
    children?: React.ReactNode
  }

export default function CheckboxWithLabel({
  className,
  checked = false,
  onChange,
  children,
  id,
  ...props
}: CheckboxWithLabelProps) {
  const defaultClassNames =
    "cursor-pointer checked:outline-none focus:outline-none focus:ring-offset-0 focus:ring-0 appearance-none"
  const cx = cn(defaultClassNames, className)

  return (
    <label className="flex items-center gap-2 cursor-pointer select-none">
      <input
        type="checkbox"
        className={cx}
        checked={checked}
        onChange={onChange}
        id={id}
        {...props}
      />
      {children}
    </label>
  )
}
